import React, { useEffect, useState } from 'react';
import Container from '../Container/Container';
import { get, post } from '../ApiServices/ApiServices';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './Component/Loader';
function AddAffiliatedGroup() {
    const [Groups, setGroups] = useState([]);
    const [customersData, setCustomersData] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    // const { id } = useParams();
    const location = useLocation();

    const { id } = location.state || {};

    const navigate = useNavigate()
    const ViewGroups = async () => {
        try {
            const api = `all-groups`;
            const totalData = await get(api);
            setGroups(totalData?.data?.rows);
        } catch (err) {
            console.error('Error fetching profile data:', err);
            toast.error('Failed to fetch groups');
        }
    };

    const customers = async () => {
        try {
            setIsLoading(true);
            if (id) {
                const api = `all-customers?group_id=${id},null&size=${1000}`;
                const totalData = await get(api);
                setCustomersData(totalData?.data?.rows);
            }
            else {
                const api = `get-customers-without-group`;
                const totalData = await get(api);
                setCustomersData(totalData?.data);
            }
        } catch (err) {
            console.error('Error fetching profile data:', err);
            // toast.error('Failed to fetch customers');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const api = `view-group/${id}`;
                const totalData = await get(api);
                const main = totalData?.data?.name
                const selectedGroup = document.querySelector('.affiliatSelectGroppe');
                if (selectedGroup) {
                    selectedGroup.value = main;
                }
                const selectedCustomerIds = totalData?.data?.users.map((data) => data.id);
                setSelectedCustomers(selectedCustomerIds);
            } catch (err) {
                console.error('Error fetching profile data:', err);
                toast.error('Failed to fetch group details');
            } finally {
                setIsLoading(false);
            }
        };
        if (id) {
            fetchData();
        }
    }, [id]);

    useEffect(() => {
        customers();
        if (location?.pathname == "/add-affiliated-group/assign") {
            ViewGroups();
        }
    }, []);

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);
        if (isChecked) {
            const allCustomerIds = customersData.map(customer => customer.id);
            setSelectedCustomers(allCustomerIds);
        } else {
            setSelectedCustomers([]);
        }
    };

    const handleCustomerSelect = (e, customerId) => {
        const isChecked = e.target.checked;
        let updatedSelectedCustomers;
        if (isChecked) {
            updatedSelectedCustomers = [...selectedCustomers, customerId];
        } else {
            updatedSelectedCustomers = selectedCustomers.filter(id => id !== customerId);
            setSelectAll(false);
        }
        setSelectedCustomers(updatedSelectedCustomers);
        if (updatedSelectedCustomers.length === customersData.length) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    };

    const Submit = async () => {
        try {
            setIsSubmitting(true);
            const selectedGroup = document.querySelector('.affiliatSelectGroppe').value;
            if (!selectedGroup) {
                toast.error('Please select or enter a group name', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });
                return;
            }

            const payload = {
                name: selectedGroup,
                customers: selectedCustomers
            };

            let api;

            if (location?.pathname === "/add-affiliated-group/assign") {
                api = `assign-group-customers/${selectedGroupId}`;
            } else if (id) {
                api = `edit-group/${id}`;
            } else {
                api = "create-group";
            }
            const totalData = await post(api, payload);
            console.log(totalData?.status, "totalDatatotalDatatotalData000000000000")
            toast.success(totalData?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            if (totalData?.status == true) {
                setTimeout(() => {
                    navigate(-1)
                }, 1500);
            }

        } catch (err) {
            console.error('Error submitting data:', err);
            toast.error('Failed to save group');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleChange = (event) => {
        const selectedGroup = Groups.find(group => group.name === event.target.value);
        setSelectedGroupId(selectedGroup ? selectedGroup.id : '');
    };

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Alternate pickup location</h3>
                                    </div>

                                    <div className="">
                                        <span
                                            onClick={() => navigate(-1)}
                                            className="btn btn-outline-light"
                                        >
                                            <em class="icon ni ni-arrow-left"></em> <span> Back</span>
                                        </span>
                                    </div>
                                </div>

                            </div>

                            <div className="card card-full">
                                <div className="card-inner">
                                    <>
                                        <div className="card-title-group mb-3">
                                            <div className="card-tools">
                                                <div className="form-control-wrap">
                                                    <label>Alternate pickup location Group Name</label>
                                                    {
                                                        location?.pathname === "/add-affiliated-group/assign" ? (
                                                            <select
                                                                className="form-control affiliatSelectGroppe"
                                                                onChange={handleChange}
                                                                value={Groups?.find(group => group?.id === selectedGroupId)?.name || ''}
                                                            >
                                                                <option value="">Select an option</option>
                                                                {Groups?.map((data) => (
                                                                    <option key={data?.id} value={data?.name}>
                                                                        {data?.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        ) : (
                                                            <input
                                                                type="text"
                                                                className="form-control affiliatSelectGroppe"
                                                                placeholder="Enter group name"
                                                            />
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">
                                                            <div className="custom-control custom-control-sm custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="customCheck7"
                                                                    checked={selectAll}
                                                                    onChange={handleSelectAll}
                                                                />
                                                                <label className="custom-control-label" htmlFor="customCheck7"></label>
                                                            </div>
                                                        </th>
                                                        <th scope="col">Owner</th>
                                                        <th scope="col">Account</th>

                                                        <th scope="col">Company name</th>

                                                        <th scope="col">Location</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        // Show multiple loader rows while loading
                                                        <tr>
                                                            <th></th>
                                                            <td>
                                                                <div className="custom-control custom-control-sm custom-checkbox">
                                                                    <div className="skeleton-checkbox"></div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <Loader />
                                                                </div>

                                                            </td>
                                                            <td>
                                                            </td>
                                                        </tr>
                                                    ) : customersData?.length > 0 ? (
                                                        // Show data when available
                                                        customersData.map((data) => {

                                                            console.log(data, "============")
                                                            return (
                                                                <>
                                                                    <tr key={data.id}>
                                                                        <th scope="row">
                                                                            <div className="custom-control custom-control-sm custom-checkbox">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="custom-control-input"
                                                                                    id={`customCheck${data.id}`}
                                                                                    checked={selectedCustomers.includes(data?.id)}
                                                                                    onChange={(e) => handleCustomerSelect(e, data?.id)}
                                                                                />
                                                                                <label className="custom-control-label" htmlFor={`customCheck${data?.id}`}></label>
                                                                            </div>
                                                                        </th>

                                                                        <td><em className="icon ni ni-user-alt"></em> {data?.firstName} {data?.lastName}</td>
                                                                        <td> {data?.account} </td>

                                                                        <td>
                                                                            {data?.companyName}
                                                                        </td>
                                                                        <td>
                                                                            {data?.addresses[0]?.billingAddress || 'N/A'} {data?.addresses[0]?.billingCity || ''} {data?.addresses[0]?.billingState || ''} {data?.addresses[0]?.billingZip || ''}
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )

                                                        })
                                                    ) : (
                                                        // Show no data message when array is empty
                                                        <tr>
                                                            <td colSpan="3" className="text-center">
                                                                <div className="data-not-found">
                                                                    <em className="icon ni ni-info"></em>
                                                                    <p>No data available</p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {
                                            customersData?.length > 0 && <button
                                                type="submit"
                                                onClick={Submit}
                                                className="addBtnCustomer btnWidthUpdte mt-3"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                ) : null}
                                                {id ? "Update Group" : location?.pathname == "/add-affiliated-group/assign" ? "Assign Group" : "Create Group"}
                                            </button>
                                        }

                                    </>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default AddAffiliatedGroup;